export default "__VITE_ASSET__a9cc6753__";